import { Civility } from '@eogile/agrements-common/src/common-types/civilityTypes';

export const fdjCivilityLabels: Record<Civility, string> = {
  [Civility.MR]: 'M.',
  [Civility.MS]: 'Mme',
};
